export default __webpack_public_path__ + "static/media/NW0010.34I-30939_-25152_0.077abf9b.jpg";